import { render, staticRenderFns } from "./Biocontrol.vue?vue&type=template&id=245a7c6e&scoped=true&lang=pug&"
import script from "./Biocontrol.vue?vue&type=script&lang=js&"
export * from "./Biocontrol.vue?vue&type=script&lang=js&"
import style0 from "./Biocontrol.vue?vue&type=style&index=0&id=245a7c6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245a7c6e",
  null
  
)

export default component.exports